import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomeView.vue'
import QuemSomos from '../views/QuemSomosView.vue'
import Produtos from '../views/ProdutosView.vue'
import ProdutosDetalhe from '../views/ProdutosDetalheView.vue'
import Clientes from '../views/ClientesView.vue'
import Contato from '../views/ContatoView.vue'
import Carrinho from '../views/CarrinhoView.vue'
import CarrinhoEndereco from '../views/CarrinhoEnderecoView.vue'
import CarrinhoFinal from '../views/CarrinhoFinalView.vue'
import Noticias from '../views/NoticiasView.vue'
import NoticiasDetalhe from '../views/NoticiasDetalheView.vue'
import Informacoes from '../views/InformacoesView.vue'


const routes = [
 { path: '/', name: 'Home', component: Home },
 { path: '/quemsomos', name: 'Quem Somos', component: QuemSomos },
 { path: '/produtos/:id?/:nome?', name: 'Produtos', component: Produtos },
 { path: '/produtosdetalhe/:id/:nome', name: 'Produtos Detalhe', component: ProdutosDetalhe },
 { path: '/clientes', name: 'Clientes', component: Clientes },
 { path: '/contato', name: 'Contato', component: Contato },
 { path: '/carrinho', name: 'Carrinho', component: Carrinho },
 { path: '/carrinhoendereco', name: 'Carrinho Endereço', component: CarrinhoEndereco },
 { path: '/carrinhofinal', name: 'Carrinho Final', component: CarrinhoFinal },
 { path: '/noticias', name: 'Noticias', component: Noticias },
 { path: '/noticiasdetalhe/:id/:nome', name: 'NoticiasDetalhe', component: NoticiasDetalhe },
 { path: '/informacoes/:id/:nome', name: 'Informacoes', component: Informacoes },
  
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
  next()
})

export default router